const pageSize = 50;
let pagingMap = new Map();
let p = {
    getPage(apiUrl) {
        let page = pagingMap.get(apiUrl);
        return page;
    }
}

pagingMap.set("/api/accountSetting/getAccountListByFirm", { "number": 1, "size": pageSize,"count":1 });

export default p;


// WEBPACK FOOTER //
// ./src/api/paging.js